import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Card, Button, Form, Row, Col, Badge, Container, Tabs, Tab, Nav } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import Pagination from 'react-js-pagination';
import * as moment from 'moment';
import { toast } from 'react-toastify';
import { DANGKY_DOTTUYENSINH_API, DOTTUYENSINH_API, LOPDAOTAOLIENTUC_API, LOPDAOTAOTHUCHANH_API, DONVI_API, DOITUONG_API } from '@app/utils/apiUrl';
import { Get } from '@app/utils/httpProvider';
import { createUrlWithParam } from '../../../../../utils/helper';
import { URI_INTERNAL } from '../../../../../utils/pathLocations';
import { 
    loaiTuyenSinhValue,
    objectLoaiTuyenSinh,
    trangThaiDotTuyenSinhValue,
    objectTrangThaiDotTuyenSinh,
    doiTuongValue,
    objectDoiTuong,
    DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT,
    objectShowNumber
} from '../../../../../utils/define';
import DangKyHoSoModal from '../hoSoTuyenSinh/DangKyHoSoModal';
import DangKyHoSoLopDaoTaoModal from '../hoSoTuyenSinh/DangKyHoSoLopDaoTaoModal';
import ChiTietLopDaoTaoLienTucModal from '../lopDaoTaoLienTuc/ChiTietLopDaoTaoLienTucModal';
import ChiTietLopDaoTaoThucHanhModal from '../lopDaoTaoThucHanh/ChiTietLopDaoTaoThucHanhModal';
import { parseDoiTuongMienGiam } from './DoiTuongMienGiamFields';

const DangKyDotTuyenSinh = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [activeTab, setActiveTab] = useState('huongDan');
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');
    const [namTuyenSinh, setNamTuyenSinh] = useState(new Date().getFullYear());

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (paramUrl.get('page') != null && parseInt(paramUrl.get('page'), 10) !== page) {
        setPage(parseInt(paramUrl.get('page'), 10));
    }
    if (paramUrl.get('size') != null && parseInt(paramUrl.get('size'), 10) !== pageSize) {
        setPageSize(parseInt(paramUrl.get('size'), 10));
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }
    if (paramUrl.get('nam') != null && parseInt(paramUrl.get('nam'), 10) !== namTuyenSinh) {
        setNamTuyenSinh(parseInt(paramUrl.get('nam'), 10));
    }

    const replaceHistory = (Page, Size, Search, Nam) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.DANGKY_DOTTUYENSINH_PATH, {
                page: Page,
                size: Size,
                search: Search,
                nam: Nam
            })
        );
    };

    const { isLoading, isError, error, data, refetch } = useQuery(
        ['dotTuyenSinhDangKyData', valueSearch, page, pageSize, namTuyenSinh],
        () => {
            const model = {
                Keyword: valueSearch || '',
                PageIndex: page,
                PageSize: pageSize,
                NamTuyenSinh: namTuyenSinh
            };
            replaceHistory(page, pageSize, valueSearch, namTuyenSinh);
            return Get(DOTTUYENSINH_API.GET_PAGING_NOT_MENU, null, model);
        },
        {
            keepPreviousData: true,
            enabled: activeTab === 'dotTuyenSinh'
        }
    );

    const { isLoading: isLoadingLienTuc, isError: isErrorLienTuc, error: errorLienTuc, data: dataLienTuc, refetch: refetchLienTuc } = useQuery(
        ['lopDaoTaoLienTucDangKyData', valueSearch, page, pageSize, namTuyenSinh],
        () => {
            const model = {
                Keyword: valueSearch || '',
                PageIndex: page,
                PageSize: pageSize,
                NamKhaiGiang: namTuyenSinh
            };
            return Get(LOPDAOTAOLIENTUC_API.GET_PAGING_NOT_MENU, null, model);
        },
        { keepPreviousData: true, enabled: activeTab === 'lopDaoTaoLienTuc' }
    );

    const { data: donViData } = useQuery(
        ['donViDataLopLienTuc'],
        () => Get(DONVI_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1000 }),
        { keepPreviousData: true }
    );
    const listDonVi = donViData?.data?.$values || donViData?.data || [];
    const getDonViName = (id) => {
        if (!id) return '';
        const found = listDonVi.find(x => x.id === id || x.Id === id);
        return found ? (found.tenDonVi || found.TenDonVi) : id;
    };

    const { isLoading: isLoadingThucHanh, isError: isErrorThucHanh, error: errorThucHanh, data: dataThucHanh, refetch: refetchThucHanh } = useQuery(
        ['lopDaoTaoThucHanhDangKyData', valueSearch, page, pageSize, namTuyenSinh],
        () => {
            const model = {
                Keyword: valueSearch || '',
                PageIndex: page,
                PageSize: pageSize,
                NamKhaiGiang: namTuyenSinh
            };
            return Get(LOPDAOTAOTHUCHANH_API.GET_PAGING_NOT_MENU, null, model);
        },
        { keepPreviousData: true, enabled: activeTab === 'lopDaoTaoThucHanh' }
    );

    const { data: doiTuongData } = useQuery(
        ['doiTuongDataLopThucHanh'],
        () => Get(DOITUONG_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1000 }),
        { keepPreviousData: true }
    );
    const listDoiTuong = doiTuongData?.data?.$values || doiTuongData?.data || [];
    const getChucDanhName = (ids) => {
        if (!ids) return '';
        const idArray = ids.split(',');
        const names = idArray.map(id => {
            const found = listDoiTuong.find(x => x.id === id || x.Id === id);
            return found ? (found.tenDoiTuong || found.TenDoiTuong) : id;
        });
        return names.join(', ');
    };

    const { data: listNamDataTS } = useQuery(
        ['listNamTuyenSinh'],
        () => Get(DOTTUYENSINH_API.GET_LIST_NAM, null, null),
        { keepPreviousData: true }
    );
    const { data: listNamDataLT } = useQuery(
        ['listNamLienTuc'],
        () => Get(LOPDAOTAOLIENTUC_API.GET_LIST_NAM_KHAI_GIANG, null, null),
        { keepPreviousData: true }
    );
    const { data: listNamDataTH } = useQuery(
        ['listNamThucHanh'],
        () => Get(LOPDAOTAOTHUCHANH_API.GET_LIST_NAM_KHAI_GIANG, null, null),
        { keepPreviousData: true }
    );

    let rawListNam = [];
    if (activeTab === 'dotTuyenSinh') {
        rawListNam = (Array.isArray(listNamDataTS) ? listNamDataTS : listNamDataTS?.$values) || [];
    } else if (activeTab === 'lopDaoTaoLienTuc') {
        rawListNam = (Array.isArray(listNamDataLT) ? listNamDataLT : listNamDataLT?.$values) || [];
    } else if (activeTab === 'lopDaoTaoThucHanh') {
        rawListNam = (Array.isArray(listNamDataTH) ? listNamDataTH : listNamDataTH?.$values) || [];
    }
    const listNam = rawListNam.length > 0 ? Array.from(new Set(rawListNam)).sort((a, b) => a - b) : [new Date().getFullYear()];

    useEffect(() => {
        if (rawListNam.length > 0 && !rawListNam.includes(namTuyenSinh)) {
            const maxYear = Math.max(...rawListNam);
            setNamTuyenSinh(maxYear);
            replaceHistory(1, pageSize, search, maxYear);
        }
    }, [activeTab, listNamDataTS, listNamDataLT, listNamDataTH, namTuyenSinh]);

    useEffect(() => {
        if (activeTab === 'dotTuyenSinh') {
            refetch();
        } else if (activeTab === 'lopDaoTaoLienTuc') {
            refetchLienTuc();
        } else if (activeTab === 'lopDaoTaoThucHanh') {
            refetchThucHanh();
        }
    }, [activeTab, pageSize, page, namTuyenSinh]);

    useEffect(() => {
        if (valueSearch != null && valueSearch !== search) {
            setPage(1);
            replaceHistory(1, pageSize, valueSearch, namTuyenSinh);
        }
    }, [valueSearch]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search, namTuyenSinh);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(Number(e.target.value));
        replaceHistory(page, Number(e.target.value), search, namTuyenSinh);
    };

    const onChangeNamTuyenSinh = (e) => {
        const nam = Number(e.target.value);
        setNamTuyenSinh(nam);
        setPage(1);
        replaceHistory(1, pageSize, search, nam);
    };

    const [showModal, setShowModal] = useState(false);
    const [selectedDotTuyenSinh, setSelectedDotTuyenSinh] = useState(null);

    const [showChiTietLienTuc, setShowChiTietLienTuc] = useState(false);
    const [selectedLienTuc, setSelectedLienTuc] = useState(null);

    const [showChiTietThucHanh, setShowChiTietThucHanh] = useState(false);
    const [selectedThucHanh, setSelectedThucHanh] = useState(null);

    const [showLopDaoTaoModal, setShowLopDaoTaoModal] = useState(false);
    const [loaiTuyenSinhModal, setLoaiTuyenSinhModal] = useState(1);

    const handleRegister = (id) => {
        setSelectedDotTuyenSinh(id);
        setShowModal(true);
    };

    const handleViewChiTietLienTuc = (item) => {
        setSelectedLienTuc(item);
        setShowChiTietLienTuc(true);
    };

    const handleViewChiTietThucHanh = (item) => {
        setSelectedThucHanh(item);
        setShowChiTietThucHanh(true);
    };

    const handleSelectTab = (k) => {
        setActiveTab(k);
        setPage(1);
    };

    const handleRegisterOther = (id, loaiTuyenSinh) => {
        setSelectedDotTuyenSinh(id);
        setLoaiTuyenSinhModal(loaiTuyenSinh);
        setShowLopDaoTaoModal(true);
    };

    const items = data?.data?.$values ? data.data.$values : data?.data || [];
    const totalRecords = data?.totalRecords || 0;

    const getLabelFromEnum = (value, objectEnum, valueMap) => {
        if (value === null || value === undefined) return '';
        const actualValue = typeof value === 'string' && valueMap ? valueMap[value] : value;
        const found = objectEnum.find((item) => item.value === actualValue);
        return found ? found.label : '';
    };

    return (
        <div className="container-fluid">

            <Tab.Container activeKey={activeTab} onSelect={handleSelectTab} id="tabs-dang-ky-tuyen-sinh">
                <Card>
                    <Card.Header>
                        <div className="d-flex justify-content-between align-items-center">
                            <Nav variant="pills" className="flex-row">
                                <Nav.Item>
                                    <Nav.Link eventKey="huongDan" className="font-weight-bold" style={{ fontSize: '16px' }}>Hướng dẫn đăng ký</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="dotTuyenSinh" className="font-weight-bold" style={{ fontSize: '16px' }}>Tuyển sinh Tiến sĩ</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="lopDaoTaoLienTuc" className="font-weight-bold" style={{ fontSize: '16px' }}>Tuyển sinh đào tạo liên tục</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="lopDaoTaoThucHanh" className="font-weight-bold" style={{ fontSize: '16px' }}>Tuyển sinh đào tạo thực hành</Nav.Link>
                                </Nav.Item>
                            </Nav>
                            <div className="d-flex align-items-center">
                                <span className="font-weight-bold mr-2">Năm:</span>
                                <Form.Control as="select" value={namTuyenSinh} onChange={onChangeNamTuyenSinh} style={{ width: '120px' }}>
                                    {listNam.map((year) => (
                                        <option key={year} value={year}>{year}</option>
                                    ))}
                                </Form.Control>
                            </div>
                        </div>
                    </Card.Header>
                    <Card.Body>
                        <Tab.Content>
                    <Tab.Pane eventKey="dotTuyenSinh">

                    {isLoading ? (
                <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Đang tải...</span>
                    </div>
                </div>
            ) : isError ? (
                <div className="alert alert-danger text-center">
                    Lỗi: {error?.message || 'Không tải được dữ liệu'}
                </div>
            ) : items.length === 0 ? (
                <div className="alert alert-info text-center py-5">
                    Hiện tại không có đợt tuyển sinh nào đang mở.
                </div>
            ) : (
                <>
                    <Row>
                        {items.map((item, index) => {
                            const doiTuongLabel = getLabelFromEnum(item.doiTuong ?? item.DoiTuong, objectDoiTuong, doiTuongValue);
                            const loaiTSLabel = getLabelFromEnum(item.loaiTuyenSinh ?? item.LoaiTuyenSinh, objectLoaiTuyenSinh, loaiTuyenSinhValue);
                            const trangThaiLabel = getLabelFromEnum(item.trangThaiDotTuyenSinh ?? item.TrangThaiDotTuyenSinh, objectTrangThaiDotTuyenSinh, trangThaiDotTuyenSinhValue);
                            const doiTuongMienGiamLabel = parseDoiTuongMienGiam(
                                item.doiTuongMienGiam ?? item.DoiTuongMienGiam ?? ''
                            ).map(doiTuong => doiTuong.tenDoiTuong).join(', ') || 'Không có';
                            
                            const valDoiTuong = item.doiTuong ?? item.DoiTuong;
                            const actualDoiTuong = typeof valDoiTuong === 'string' ? doiTuongValue[valDoiTuong] : valDoiTuong;
                            const quan = item.chiTieuQuan ?? item.ChiTieuQuan ?? 0;
                            const dan = item.chiTieuDan ?? item.ChiTieuDan ?? 0;
                            
                            let chiTieuStr = '0';
                            if (actualDoiTuong === doiTuongValue.quan) chiTieuStr = `${quan}`;
                            else if (actualDoiTuong === doiTuongValue.khac) chiTieuStr = `${dan}`;
                            else if (actualDoiTuong === doiTuongValue.quanVaDan) chiTieuStr = `Quân: ${quan} | Dân: ${dan}`;

                            const fee = new Intl.NumberFormat('vi-VN').format(item.lePhi ?? item.LePhi ?? 0);
                            
                            const tStart = (item.ngayNhanHoSo || item.NgayNhanHoSo) ? moment(item.ngayNhanHoSo || item.NgayNhanHoSo).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT) : '?';
                            const tEnd = (item.ngayKetThucNhanHoSo || item.NgayKetThucNhanHoSo) ? moment(item.ngayKetThucNhanHoSo || item.NgayKetThucNhanHoSo).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT) : '?';

                            return (
                                <Col lg={4} md={6} sm={12} className="mb-4" key={item.id || index}>
                                    <Card className="h-100 shadow-sm border-0" style={{ transition: 'transform 0.2s', borderRadius: '12px', overflow: 'hidden' }}
                                          onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                                          onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                                        <div style={{ height: '6px', backgroundColor: '#007bff' }}></div>
                                        <Card.Body className="d-flex flex-column">
                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                <Badge variant="primary" className="mb-2 px-2 py-1" style={{ fontSize: '13px', borderRadius: '4px' }}>Năm: {item.namTuyenSinh || item.NamTuyenSinh}</Badge>
                                                <Badge 
                                                    variant={
                                                        trangThaiLabel === 'Đang mở' ? 'success' : 
                                                        trangThaiLabel === 'Đã đóng' ? 'danger' : 
                                                        trangThaiLabel === 'Tạm dừng' ? 'warning' : 'secondary'
                                                    } 
                                                    className="px-2 py-1" style={{ fontSize: '13px', borderRadius: '4px' }}
                                                >
                                                    {trangThaiLabel}
                                                </Badge>
                                            </div>
                                            <Card.Title className="font-weight-bold" style={{ fontSize: '1.2rem', color: '#34495e', lineHeight: '1.4' }}>
                                                {item.tenDot || item.TenDot}
                                            </Card.Title>
                                            
                                            <div className="mt-3 flex-grow-1" style={{ fontSize: '14px', color: '#555' }}>
                                                <div className="mb-2"><i className="fas fa-graduation-cap text-primary mr-2" style={{ width: '16px' }}></i> <strong>Loại TS:</strong> {loaiTSLabel}</div>
                                                <div className="mb-2"><i className="fas fa-users text-primary mr-2" style={{ width: '16px' }}></i> <strong>Đối tượng:</strong> {doiTuongLabel}</div>
                                                <div className="mb-2"><i className="fas fa-percentage text-primary mr-2" style={{ width: '16px' }}></i> <strong>Đối tượng miễn giảm:</strong> {doiTuongMienGiamLabel}</div>
                                                <div className="mb-2"><i className="fas fa-chart-bar text-primary mr-2" style={{ width: '16px' }}></i> <strong>Chỉ tiêu:</strong> {chiTieuStr}</div>
                                                <div className="mb-2"><i className="fas fa-money-bill-wave text-primary mr-2" style={{ width: '16px' }}></i> <strong>Lệ phí:</strong> <span className="text-danger font-weight-bold">{fee} VNĐ</span></div>
                                                <div className="mb-2">
                                                    <i className="far fa-calendar-alt text-primary mr-2" style={{ width: '16px' }}></i> 
                                                    <strong>Thời gian nhận hồ sơ:</strong>
                                                    <div className="ml-4 mt-1 text-muted" style={{ fontSize: '13px' }}>{tStart} - {tEnd}</div>
                                                </div>
                                            </div>

                                            <div className="mt-4 pt-3 border-top text-center">
                                                <Button 
                                                    variant={trangThaiLabel === 'Đang mở' ? "primary" : "secondary"} 
                                                    block 
                                                    className="font-weight-bold rounded-pill shadow-sm" 
                                                    onClick={() => handleRegister(item.id)} 
                                                    style={{ padding: '10px 20px', fontSize: '15px', opacity: trangThaiLabel === 'Đang mở' ? 1 : 0.6 }}
                                                    disabled={trangThaiLabel !== 'Đang mở'}
                                                >
                                                    <i className="fas fa-edit mr-2"></i> Đăng ký ngay
                                                </Button>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            );
                        })}
                    </Row>
                    
                    {/* <div className="d-flex justify-content-between align-items-center mt-3">
                        <div>
                            <Form.Control as="select" value={pageSize} onChange={onChangeShowNumber} style={{ width: '100px' }}>
                                {objectShowNumber.map((opt) => (
                                    <option key={opt.value} value={opt.value}>{opt.text}</option>
                                ))}
                            </Form.Control>
                        </div>
                        <div>
                            <Pagination
                                itemClass="page-item"
                                linkClass="page-link"
                                innerClass="pagination pagination-sm no-margin"
                                activePage={page}
                                itemsCountPerPage={pageSize}
                                totalItemsCount={totalRecords}
                                pageRangeDisplayed={5}
                                onChange={changePage}
                            />
                        </div>
                    </div> */}
                </>
            )}
                    </Tab.Pane>
                    <Tab.Pane eventKey="lopDaoTaoLienTuc">
                        {isLoadingLienTuc ? (
                            <div className="text-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Đang tải...</span>
                                </div>
                            </div>
                        ) : isErrorLienTuc ? (
                            <div className="alert alert-danger text-center">
                                Lỗi: {errorLienTuc?.message || 'Không tải được dữ liệu'}
                            </div>
                        ) : (dataLienTuc?.data?.$values || dataLienTuc?.data || []).length === 0 ? (
                            <div className="alert alert-info text-center py-5">
                                Hiện tại không có lớp đào tạo liên tục nào đang mở.
                            </div>
                        ) : (
                            <Row>
                                {(dataLienTuc?.data?.$values || dataLienTuc?.data || []).map((item, index) => {
                                    const loaiTSLabel = getLabelFromEnum(item.loaiTuyenSinh ?? item.LoaiTuyenSinh, objectLoaiTuyenSinh, loaiTuyenSinhValue);
                                    const trangThaiLabel = getLabelFromEnum(item.trangThaiDotTuyenSinh ?? item.TrangThaiDotTuyenSinh, objectTrangThaiDotTuyenSinh, trangThaiDotTuyenSinhValue);
                                    
                                    const fee = new Intl.NumberFormat('vi-VN').format(item.hocPhi ?? item.HocPhi ?? 0);
                                    const doiTuongMienGiamLabel = parseDoiTuongMienGiam(
                                        item.doiTuongMienGiam ?? item.DoiTuongMienGiam ?? ''
                                    ).map(doiTuong => doiTuong.tenDoiTuong).join(', ') || 'Không có';
                                    
                                    const tStart = (item.ngayKhaiGiang || item.NgayKhaiGiang) ? moment(item.ngayKhaiGiang || item.NgayKhaiGiang).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT) : '?';
                                    const tEnd = (item.ngayBeGiang || item.NgayBeGiang) ? moment(item.ngayBeGiang || item.NgayBeGiang).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT) : '?';
                                    const donViXuatStr = getDonViName(item.khoaDeXuatId || item.KhoaDeXuatId);

                                    return (
                                        <Col lg={4} md={6} sm={12} className="mb-4" key={item.id || index}>
                                            <Card className="h-100 shadow-sm border-0" style={{ transition: 'transform 0.2s', borderRadius: '12px', overflow: 'hidden' }}
                                                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                                                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                                                <div style={{ height: '6px', backgroundColor: '#007bff' }}></div>
                                                <Card.Body className="d-flex flex-column">
                                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                                        <Badge variant="primary" className="mb-2 px-2 py-1" style={{ fontSize: '13px', borderRadius: '4px' }}>Năm: {namTuyenSinh}</Badge>
                                                        <Badge 
                                                            variant={
                                                                trangThaiLabel === 'Đang mở' ? 'success' : 
                                                                trangThaiLabel === 'Đã đóng' ? 'danger' : 
                                                                trangThaiLabel === 'Tạm dừng' ? 'warning' : 'secondary'
                                                            } 
                                                            className="px-2 py-1" style={{ fontSize: '13px', borderRadius: '4px' }}
                                                        >
                                                            {trangThaiLabel}
                                                        </Badge>
                                                    </div>
                                                    <Card.Title className="font-weight-bold" style={{ fontSize: '1.2rem', color: '#34495e', lineHeight: '1.4' }}>
                                                        {item.tenKhoaHoc || item.TenKhoaHoc}
                                                    </Card.Title>
                                                    
                                                    <div className="mt-3 flex-grow-1" style={{ fontSize: '14px', color: '#555' }}>
                                                        <div className="mb-2"><i className="fas fa-graduation-cap text-primary mr-2" style={{ width: '16px' }}></i> <strong>Loại TS:</strong> {loaiTSLabel}</div>
                                                        <div className="mb-2"><i className="fas fa-building text-primary mr-2" style={{ width: '16px' }}></i> <strong>Khoa:</strong> {donViXuatStr}</div>
                                                        <div className="mb-2"><i className="fas fa-users text-primary mr-2" style={{ width: '16px' }}></i> <strong>Số lượng HV:</strong> {item.soLuongHocVien || item.SoLuongHocVien}</div>
                                                        <div className="mb-2"><i className="fas fa-percentage text-primary mr-2" style={{ width: '16px' }}></i> <strong>Đối tượng miễn giảm:</strong> {doiTuongMienGiamLabel}</div>
                                                        <div className="mb-2"><i className="fas fa-money-bill-wave text-primary mr-2" style={{ width: '16px' }}></i> <strong>Học phí:</strong> <span className="text-danger font-weight-bold">{fee} VNĐ</span></div>
                                                        <div className="mb-2">
                                                            <i className="far fa-calendar-alt text-primary mr-2" style={{ width: '16px' }}></i> 
                                                            <strong>Thời gian học:</strong>
                                                            <div className="ml-4 mt-1 text-muted" style={{ fontSize: '13px' }}>{tStart} - {tEnd}</div>
                                                        </div>
                                                    </div>

                                                    <div className="mt-4 pt-3 border-top d-flex justify-content-between">
                                                        <Button 
                                                            variant="outline-primary" 
                                                            className="font-weight-bold rounded-pill shadow-sm" 
                                                            onClick={() => handleViewChiTietLienTuc(item)} 
                                                            style={{ padding: '8px 10px', fontSize: '14px', flex: 1, marginRight: '8px' }}
                                                        >
                                                            <i className="fas fa-info-circle mr-1"></i> Xem chi tiết
                                                        </Button>
                                                        <Button 
                                                            variant={trangThaiLabel === 'Đang mở' ? "primary" : "secondary"} 
                                                            className="font-weight-bold rounded-pill shadow-sm" 
                                                            onClick={() => handleRegisterOther(item.id, 1)} 
                                                            style={{ padding: '8px 10px', fontSize: '14px', flex: 1, opacity: trangThaiLabel === 'Đang mở' ? 1 : 0.6 }}
                                                            disabled={trangThaiLabel !== 'Đang mở'}
                                                        >
                                                            <i className="fas fa-edit mr-1"></i> Đăng ký ngay
                                                        </Button>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    );
                                })}
                            </Row>
                        )}
                    </Tab.Pane>
                    <Tab.Pane eventKey="lopDaoTaoThucHanh">
                        {isLoadingThucHanh ? (
                            <div className="text-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Đang tải...</span>
                                </div>
                            </div>
                        ) : isErrorThucHanh ? (
                            <div className="alert alert-danger text-center">
                                Lỗi: {errorThucHanh?.message || 'Không tải được dữ liệu'}
                            </div>
                        ) : (dataThucHanh?.data?.$values || dataThucHanh?.data || []).length === 0 ? (
                            <div className="alert alert-info text-center py-5">
                                Hiện tại không có lớp đào tạo thực hành nào đang mở.
                            </div>
                        ) : (
                            <Row>
                                {(dataThucHanh?.data?.$values || dataThucHanh?.data || []).map((item, index) => {
                                    const loaiTSLabel = getLabelFromEnum(item.loaiTuyenSinh ?? item.LoaiTuyenSinh, objectLoaiTuyenSinh, loaiTuyenSinhValue);
                                    const trangThaiLabel = getLabelFromEnum(item.trangThaiDotTuyenSinh ?? item.TrangThaiDotTuyenSinh, objectTrangThaiDotTuyenSinh, trangThaiDotTuyenSinhValue);
                                    const doiTuongLabel = getLabelFromEnum(item.doiTuongEnum ?? item.DoiTuongEnum, objectDoiTuong, doiTuongValue);
                                    const doiTuongMienGiamLabel = parseDoiTuongMienGiam(
                                        item.doiTuongMienGiam ?? item.DoiTuongMienGiam ?? ''
                                    ).map(doiTuong => doiTuong.tenDoiTuong).join(', ') || 'Không có';
                                    const chucDanhStr = getChucDanhName(item.chucDanhIds || item.ChucDanhIds);
                                    const tStart = (item.ngayKhaiGiang || item.NgayKhaiGiang) ? moment(item.ngayKhaiGiang || item.NgayKhaiGiang).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT) : '?';

                                    return (
                                        <Col lg={4} md={6} sm={12} className="mb-4" key={item.id || index}>
                                            <Card className="h-100 shadow-sm border-0" style={{ transition: 'transform 0.2s', borderRadius: '12px', overflow: 'hidden' }}
                                                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                                                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                                                <div style={{ height: '6px', backgroundColor: '#007bff' }}></div>
                                                <Card.Body className="d-flex flex-column">
                                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                                        <Badge variant="primary" className="mb-2 px-2 py-1" style={{ fontSize: '13px', borderRadius: '4px' }}>Năm: {namTuyenSinh}</Badge>
                                                        <Badge 
                                                            variant={
                                                                trangThaiLabel === 'Đang mở' ? 'success' : 
                                                                trangThaiLabel === 'Đã đóng' ? 'danger' : 
                                                                trangThaiLabel === 'Tạm dừng' ? 'warning' : 'secondary'
                                                            } 
                                                            className="px-2 py-1" style={{ fontSize: '13px', borderRadius: '4px' }}
                                                        >
                                                            {trangThaiLabel}
                                                        </Badge>
                                                    </div>
                                                    <Card.Title className="font-weight-bold" style={{ fontSize: '1.2rem', color: '#34495e', lineHeight: '1.4' }}>
                                                        {item.tenKhoaHoc || item.TenKhoaHoc}
                                                    </Card.Title>
                                                    
                                                    <div className="mt-3 flex-grow-1" style={{ fontSize: '14px', color: '#555' }}>
                                                        <div className="mb-2"><i className="fas fa-graduation-cap text-primary mr-2" style={{ width: '16px' }}></i> <strong>Loại TS:</strong> {loaiTSLabel}</div>
                                                        <div className="mb-2"><i className="fas fa-users text-primary mr-2" style={{ width: '16px' }}></i> <strong>Đối tượng:</strong> {doiTuongLabel}</div>
                                                        <div className="mb-2"><i className="fas fa-percentage text-primary mr-2" style={{ width: '16px' }}></i> <strong>Đối tượng miễn giảm:</strong> {doiTuongMienGiamLabel}</div>
                                                        <div className="mb-2"><i className="fas fa-briefcase text-primary mr-2" style={{ width: '16px' }}></i> <strong>Chức danh:</strong> {chucDanhStr}</div>
                                                        <div className="mb-2">
                                                            <i className="far fa-calendar-alt text-primary mr-2" style={{ width: '16px' }}></i> 
                                                            <strong>Ngày khai giảng:</strong>
                                                            <div className="ml-4 mt-1 text-muted" style={{ fontSize: '13px' }}>{tStart}</div>
                                                        </div>
                                                    </div>

                                                    <div className="mt-4 pt-3 border-top d-flex justify-content-between">
                                                        <Button 
                                                            variant="outline-primary" 
                                                            className="font-weight-bold rounded-pill shadow-sm" 
                                                            onClick={() => handleViewChiTietThucHanh(item)} 
                                                            style={{ padding: '8px 10px', fontSize: '14px', flex: 1, marginRight: '8px' }}
                                                        >
                                                            <i className="fas fa-info-circle mr-1"></i> Xem chi tiết
                                                        </Button>
                                                        <Button 
                                                            variant={trangThaiLabel === 'Đang mở' ? "primary" : "secondary"} 
                                                            className="font-weight-bold rounded-pill shadow-sm" 
                                                            onClick={() => handleRegisterOther(item.id, 2)} 
                                                            style={{ padding: '8px 10px', fontSize: '14px', flex: 1, opacity: trangThaiLabel === 'Đang mở' ? 1 : 0.6 }}
                                                            disabled={trangThaiLabel !== 'Đang mở'}
                                                        >
                                                            <i className="fas fa-edit mr-1"></i> Đăng ký ngay
                                                        </Button>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    );
                                })}
                            </Row>
                        )}
                    </Tab.Pane>
                    <Tab.Pane eventKey="huongDan">
                        <div className="bg-white p-4 rounded shadow-sm mt-3" style={{ minHeight: '500px' }}>
                        <h4 className="mb-4 text-primary font-weight-bold">Hướng dẫn các bước đăng ký tuyển sinh</h4>
                        
                        <div className="mb-4">
                            <h5><Badge variant="primary" className="mr-2">Bước 1</Badge> Chọn đợt tuyển sinh</h5>
                            <p className="ml-4 text-muted" style={{ fontSize: '15px' }}>Chuyển sang tab <strong>Đợt tuyển sinh</strong> để xem danh sách các đợt tuyển sinh đang mở. Chọn một đợt tuyển sinh phù hợp với nguyện vọng và nhấn nút <strong>Đăng ký ngay</strong>.</p>
                        </div>

                        <div className="mb-4">
                            <h5><Badge variant="primary" className="mr-2">Bước 2</Badge> Điền thông tin hồ sơ</h5>
                            <p className="ml-4 text-muted" style={{ fontSize: '15px' }}>Hệ thống sẽ hiển thị biểu mẫu đăng ký hồ sơ. Vui lòng điền đầy đủ và chính xác các thông tin cá nhân, thông tin liên hệ, quá trình học tập và công tác. Chú ý các trường có dấu (*) là bắt buộc.</p>
                        </div>

                        <div className="mb-4">
                            <h5><Badge variant="primary" className="mr-2">Bước 3</Badge> Tải lên tài liệu đính kèm</h5>
                            <p className="ml-4 text-muted" style={{ fontSize: '15px' }}>Chuẩn bị các tài liệu cần thiết (CCCD/CMND, bằng cấp, chứng chỉ, đề cương nghiên cứu,...) và tải lên hệ thống theo đúng định dạng yêu cầu (PDF, JPG, PNG).</p>
                        </div>

                        <div className="mb-4">
                            <h5><Badge variant="primary" className="mr-2">Bước 4</Badge> Xác nhận và Nộp hồ sơ</h5>
                            <p className="ml-4 text-muted" style={{ fontSize: '15px' }}>Kiểm tra lại toàn bộ thông tin đã nhập. Nếu đã chính xác, nhấn nút <strong>Lưu hồ sơ</strong> hoặc <strong>Nộp hồ sơ</strong> để hoàn tất quá trình đăng ký.</p>
                        </div>

                        <div className="alert alert-info mt-4" style={{ fontSize: '15px' }}>
                            <i className="fas fa-info-circle mr-2"></i>
                            <strong>Lưu ý:</strong> Sau khi nộp hồ sơ, bạn có thể theo dõi trạng thái xét duyệt hồ sơ của mình trong phần quản lý hồ sơ cá nhân. Vui lòng thường xuyên kiểm tra email hoặc thông báo từ hệ thống.
                        </div>
                    </div>
                    </Tab.Pane>
                        </Tab.Content>
                    </Card.Body>
                </Card>
            </Tab.Container>

            <DangKyHoSoModal 
                show={showModal} 
                handleClose={() => setShowModal(false)} 
                dotTuyenSinhId={selectedDotTuyenSinh}
            />

            <DangKyHoSoLopDaoTaoModal
                show={showLopDaoTaoModal}
                handleClose={() => setShowLopDaoTaoModal(false)}
                dotTuyenSinhId={selectedDotTuyenSinh}
                loaiTuyenSinh={loaiTuyenSinhModal}
            />

            <ChiTietLopDaoTaoLienTucModal
                isOpen={showChiTietLienTuc}
                onClose={() => setShowChiTietLienTuc(false)}
                data={selectedLienTuc}
                getDonViName={getDonViName}
                getChucDanhName={getChucDanhName}
            />

            <ChiTietLopDaoTaoThucHanhModal
                isOpen={showChiTietThucHanh}
                onClose={() => setShowChiTietThucHanh(false)}
                data={selectedThucHanh}
                getChucDanhName={getChucDanhName}
            />
        </div>
    );
};

export default DangKyDotTuyenSinh;
